import React from 'react';
import { Link } from 'gatsby';

import Section from '../components/Section';
import SimpleButton from '../components/SimpleButton';
import styles from './Events.module.scss';

const bookButtonForUrl = url => {
  if (url) {
    return (
      <a href={url}>
        <div className={styles.button}>
          <SimpleButton title="Book" />
        </div>
      </a>
    );
  }
  return '';
};

const EventItem = ({ title, description, location, url, day, month, year }) => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={`${styles.left} ${styles.col}`}>
          <div className={styles.date}>
            <span className={styles.dateDay}>{day}</span>
            <span className={styles.dateMonth}>
              {month}'{year}
            </span>
          </div>
          <div className={styles.info}>
            <div className={styles.infoTitle}>{title}</div>
            <div
              className={styles.infoDescription}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>
        <div className={`${styles.right} ${styles.col}`}>
          <div className={styles.location}>
            <div
              className={styles.locationTitle}
              dangerouslySetInnerHTML={{ __html: location }}
            />
          </div>
          {bookButtonForUrl(url)}
        </div>
      </div>
      {/*<div className={styles.separator} />*/}
    </>
  );
};

const Events = ({ events, hideTitle, hideMoreLink, transparent }) => {
  return (
    <Section title={hideTitle ? '' : 'lives'} transparent={transparent}>
      {events.map(
        ({ title, description, url, location, day, month, year }, index) => {
          return (
            <EventItem
              key={index}
              {...{ title, description, url, location, day, month, year }}
            />
          );
        }
      )}
      {!hideMoreLink && (
        <div className={styles.moreLink}>
          <Link to="/events" className={styles.moreLinkLink}>
            + More dates
          </Link>
        </div>
      )}
    </Section>
  );
};

Events.defaultProps = {
  events: []
};

export default Events;
